module.exports = {
	"layoutContext": {}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/layout-index.json
// module chunks = 60335399758886 114276838955818